import React from "react";

const RunningMarquee = ({ text = "Building better homes for a better tomorrow", dark }) => {
  const items = Array.from({ length: 8 });
  return (
    <div className={`py-5 overflow-hidden ${dark ? "bg-[#0B102D]" : "bg-[#CD0008]"} marquee-pause`}>
      <div className="animate-marquee">
        {items.map((_, i) => (
          <span key={i} className="flex items-center shrink-0">
            <span className="font-display font-extrabold uppercase text-white text-2xl md:text-3xl tracking-tight px-6">
              {text}
            </span>
            <span className="w-3 h-3 bg-white rotate-45 inline-block" />
          </span>
        ))}
      </div>
    </div>
  );
};

export default RunningMarquee;
